(function () {
  function enhancePurchaseOptions() {
    const root = document.querySelector('.template-product');
    if (!root) return;

    // Versuch: finde Labels der Kaufoptionen
    const labels = root.querySelectorAll(
      '.product-form__input label, .selling-plan-group label'
    );
    if (!labels.length) return;

    labels.forEach((label) => {
      // Nur einmal anreichern
      if (label.querySelector('.dc-po-title')) return;

      const text = (label.innerText || '').toLowerCase();

      // Basis-Wrapper
      const left = document.createElement('div');
      left.style.display = 'grid';
      left.style.gap = '2px';

      const title = document.createElement('div');
      title.className = 'dc-po-title';

      const sub = document.createElement('div');
      sub.className = 'dc-po-sub';

      // Heuristik: erkenne Abo vs Einmalkauf
      const isSub = text.includes('abo') || text.includes('monat') || text.includes('subscribe');
      title.textContent = isSub ? 'Monatliches Abo' : 'Einmalkauf';
      sub.textContent = isSub
        ? 'Spare im Vergleich zum Einzelkauf'
        : 'Einmalig bestellen – keine Folgelieferung';

      left.appendChild(title);
      left.appendChild(sub);

      // Badge nur fürs Abo
      if (isSub && !label.querySelector('.dc-po-badge')) {
        const badge = document.createElement('div');
        badge.className = 'dc-po-badge';
        badge.textContent = 'Empfohlen';
        left.appendChild(badge);
      }

      // Bestehenden Text nicht komplett löschen (Apps können IDs/Spans brauchen)
      // Wir setzen unseren Block ganz oben in das Label.
      label.prepend(left);
    });
  }

  document.addEventListener('DOMContentLoaded', enhancePurchaseOptions);
})();
